package link.erpango.quip.data.firebase

import link.erpango.quip.data.firebase.analytics.FirebaseAnalytics
import link.erpango.quip.data.firebase.auth.FirebaseAuth
import link.erpango.quip.data.firebase.config.FirebaseRemoteConfig
import link.erpango.quip.data.firebase.messaging.FirebaseMessaging

class FirebaseDataSource(

    client: IFirebaseClient

): IFirebaseDataSource {

    override val remoteConfig = FirebaseRemoteConfig(client)
    override val analytics = FirebaseAnalytics(client)
    override val messaging = FirebaseMessaging(client)
    override val auth = FirebaseAuth(client)
}
